import { render } from "./ReservationResult.vue?vue&type=template&id=5c1845d1&scoped=true"
import script from "./ReservationResult.vue?vue&type=script&lang=js"
export * from "./ReservationResult.vue?vue&type=script&lang=js"

import "./ReservationResult.vue?vue&type=style&index=0&id=5c1845d1&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1845d1"]])

export default __exports__